import * as z from 'zod';

import { competitorQuerySchema } from './competitor-query-schema';

export const competitorUpdateSchema = competitorQuerySchema
  .omit({
    status: true,
    logo: true,
    addresses: true,
    ceo_contact: true,
    associated_clients_count: true,
    primary_contact: true,
    associated_clients: true,
    current_web_clients: true,
    // creator_id: true,
  })
  .extend({
    status: z.string(),
    logo: z.array(z.number()),
    addresses: z.array(z.number()),
    primary_contact: z.array(z.number()),
    associated_clients: z.array(z.number()),
    phone_numbers: z.array(z.number()),
    ceo_contact: z.array(z.number()),
  });

export type CompetitorUpdateSchema = z.infer<typeof competitorUpdateSchema>;

export const competitorCreateSchema = competitorUpdateSchema.pick({
  name: true,
  status: true,
  business_tagline: true,
  number_of_customers: true,
  founded_date: true,
  headcount: true,
  email: true,
  website: true,
  // creator_id: true,
});

export type CompetitorCreateSchema = z.infer<typeof competitorCreateSchema>;
